module.exports = __webpack_public_path__ + "static/media/iosAddToHomeScreen.c83d1b7f.svg";